<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper" v-loading="loading">
      <!-- 新建活动 -->
      <div class="activity_new">
        <div class="normal_title">新建活动</div>
        <div class="activity-new-card is-hover-shadow">
          <el-form :inline="true"  label-position="right" :model="themeBasic" label-width="140px"
            :rules="editRules" ref="themeBasicRef">
            <el-form-item label="活动PR：">
              <div class="item">{{ $route.query.prName }}</div>
            </el-form-item>
            <el-form-item label="活动执行时间：" prop="themeTime">
              <el-date-picker v-model="themeBasic.themeTime" :clearable="false" @focus="themeTimeFocus" @blur="confirmChangeThemeTime" @change="handleAddTime" value-format="timestamp" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动名称：" prop="themeName">
              <el-input class="item" v-model="themeBasic.themeName" placeholder="输入活动名称" />
            </el-form-item>
            <el-form-item label="活动提报时间：" prop="applyTime">
              <el-date-picker v-model="themeBasic.applyTime" :clearable="false" value-format="timestamp" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动品牌：">
              {{ $route.query.brand }}
            </el-form-item>
            <el-form-item label="活动子品牌：">
              {{ $route.query.subBrand }}
            </el-form-item>
            <el-form-item label="活动渠道：" prop="themeChannelNames">
              <el-checkbox-group class="activity_channel_checkbox" v-model="themeBasic.themeChannelNames">
                <el-checkbox v-for="item in fullConfig" :key="item.themeChannelCode"
                  :label="item.themeChannelName" :v-if="item.themeStyles.length!==0">
                  <div class="activity_channel_checkbox_label">
                    {{item.themeChannelEnName }}<br />{{item.themeChannelName}}
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
             <div class="upload_section">
             <div class="upload_item">
                <div class="upload_item_title"><span style="color:white"> </span> &ensp; 上传执行手册</div>
                <FileUpload
                  ref="manualFileIdRef"
                  :upload-param="{ filePath: 'temp' }"
                  :save-item = "manualFile"
                  show-type="text"
                  @uploaded="getManualFileId"
                  @removed="clearManualFileId" >
                  <div class="upload_item_btn">上传执行手册</div>
                </FileUpload>
              </div>
              <div class="upload_item">
                <div class="upload_item_title"><span style="color:white"> </span> &ensp; 设置促销员执行数据收集模板</div>
                <FileUpload
                  ref="execTemplateIdRef"
                  :upload-param="{ filePath: 'temp' }"
                  :save-item = "execTemplate"
                  show-type="text"
                  @uploaded="getExecTemplateId"
                  @removed="clearExecTemplateId" >
                  <div class="upload_item_btn">上传模板</div>
                </FileUpload>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <div class="cross_channel" v-for="item of configItemList" :key="item.themeChannelCode">
        <ConfigItem :saveDetailList1="saveDetailList" @handleSubmit="handleSubmit" :configItem="item" ref="configItemRef" :fullConfig="fullConfig" :assignBuList="assignBuList"
        :assignRegionList="assignRegionList" :assignAreaList="assignAreaList" />
      </div>

      <div class="btn_section">
        <div v-if="saveValid" class="normal_btn btn_bg_white" @click="handleOperation('save')">保存草稿</div>
        <div v-else class="normal_btn btn_bg_white_disadled">保存草稿</div>
        <div v-if="dataValid" class="normal_btn btn_bg_red" @click="handleOperation('submit')">提交</div>
        <div v-else class="normal_btn btn_bg_red_disabled">提交</div>
      </div>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="showConfirmDialog"
      width="30%" >
      <span>是否要{{operateType==='submit'?'提交':'保存'}}当前数据？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfirmDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import FileUpload from './components/file-upload'
import gameplanApi from "@/api/gameplan";
import ContentHeader from "@/components/content-header";
import { mapGetters,mapState } from 'vuex'
import ConfigItem from './components/config-item-hq-c'
export default {
  components: {
    ContentHeader,
    ConfigItem,
    FileUpload
  },
  data() {
    var validateThemeTime = (rule, value, callback) => {
      let now = Date.now()
      if (!value||value.length===0) {
        return callback(new Error('请选择执行时间'));
      }else {
        return callback()
      }
      // if(value[0]<now){
      //   return callback(new Error('执行时间不可早于当前时间'));
      // }
    };
    var validateApplyTime = (rule, value, callback) => {
      let now = Date.now()
      if (!value||value.length===0) {
        return callback(new Error('请选择提报时间'));
      }else {
        return callback()
      }
      // if(value[0]<now){
      //   return callback(new Error('提报时间不可早于当前时间'));
      // }
    };
    return {
      loading:false,
      employeeLevel: '',
      operateType:'',
      themeBasic: {
        themeName:"",
        manualFileId:'',
        execTemplateId:'',
        themeTime:[],
        applyTime: [],
        themeChannelNames:[]
      },
      oldThemeTime: [],
      themeTime: [],
      applyTime: [],
      fullConfig: [],
      editRules: {
        themeName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        themeChannelNames: [
          { required: true, message: "请选择活动渠道", trigger: "blur" },
        ],
        themeTime:[
          {validator: validateThemeTime, trigger: 'blur'},
          { required: true, message: "请选择提报时间", trigger: "blur" },
        ],
        applyTime:[
          {validator: validateApplyTime, trigger: 'blur'},
          { required: true, message: "请选择执行时间", trigger: "blur" },
        ]
      },
      themeChannelForm: [],
      themeChannelCodes:[],
      themeChannelNames: [],
      detailList:[],
      themeInfo:{},
      saveDetailList:[],
      themeId:'',
      pickerOptions:{
        disabledDate(time) {
            return time.getTime() < Date.now();
          },
      },
      showConfirmDialog:false,
      valid:true,
      errorList:[],
      manualFile: [],
      execTemplate:[],
      dataValid:false,
      saveValid:false,
      rateErrorList:[],
      isHistory:false,
      confirmed:true,
      showChangeDateDialog:false
    };
  },
  watch:{
    'themeBasic.themeChannelNames' (val, oldVal) {
      this.saveValid = this.isSaveValid
      if(oldVal.length>val.length){
        for(let i=0;i< this.saveDetailList.length;i++){
          let channelList = this.saveDetailList[i]
          let themeChannelName = channelList[0].themeDetail.themeChannelName.split('|')[0]
          if(themeChannelName === oldVal[oldVal.length-1]){
            this.saveDetailList.splice(i,1)
            this.themeChannelCodes = []
          }
        }
      }
      if(!val){
        this.dataValid = false
        return
      }
      this.dataValid = this.isDataValid
    },
    'themeBasic.themeName' (val) {
      this.saveValid = this.isSaveValid
      if(!val){
        this.dataValid = false
        return
      }
      this.dataValid = this.isDataValid
    },
    'themeBasic.themeTime' (val,oldv) {
      this.saveValid = this.isSaveValid
      this.dataValid = this.isDataValid
      this.oldThemeTime = oldv
      if(this.themeBasic.applyTime&&val){
        if(this.themeBasic.themeTime[0]<this.themeBasic.applyTime[0]){
          this.$alert(`提报开始时间不能晚于执行开始时间！`, '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
          }).then(() => {
            this.themeBasic.themeTime = null
          })
        }
        if(this.themeBasic.themeTime[1]<=this.themeBasic.applyTime[1]){
          this.$alert(`提报结束时间需早于执行结束时间！`, '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
          }).then(() => {
            this.themeBasic.themeTime = null
          })
        }
      }
    },
    'themeBasic.applyTime' (val) {
      this.saveValid = this.isSaveValid
      this.dataValid = this.isDataValid
      if(this.themeBasic.themeTime&&val){
        //console.log(this.themeBasic.themeTime[0]>=this.themeBasic.applyTime[1]);
        if(this.themeBasic.themeTime[0]<this.themeBasic.applyTime[0]){
          this.$alert(`提报开始时间不能晚于执行开始时间！`, '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
          }).then(() => {
            this.themeBasic.applyTime = null
          })
        }
        if(this.themeBasic.themeTime[1]<=this.themeBasic.applyTime[1]){
          this.$alert(`提报结束时间需早于执行结束时间！`, '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
          }).then(() => {
            this.themeBasic.applyTime = null
          })
        }
      }
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget,
    }),
    ...mapGetters(['userInfo']),
    configItemList() {
      this.themeChannelForm = []
      this.themeChannelCodes = []
      for (let detail of this.fullConfig) {
        for (let item of this.themeBasic.themeChannelNames) {
          if (item === detail.themeChannelName) {
            this.themeChannelCodes.push(detail.themeChannelCode)
            this.themeChannelForm.splice(this.themeChannelForm.length,0,detail)
          }
        }
      }
      return this.themeChannelForm
    },
    isDataValid(){
      let data = {
        themeName:this.themeBasic.themeName,
        //manualFileId:this.themeBasic.manualFileId,
        //execTemplateId:this.themeBasic.execTemplateId,
        themeTime:this.themeBasic.themeTime,
        applyTime: this.themeBasic.applyTime,
        themeChannelNames:this.themeBasic.themeChannelNames
      }
      for(let key in data){
        if(!data[key]||data[key].length===0){
          return false
        }
      }
      return true
    },
    isSaveValid(){
      let data = {
        themeName:this.themeBasic.themeName,
        //manualFileId:this.themeBasic.manualFileId,
        //execTemplateId:this.themeBasic.execTemplateId,
        themeTime:this.themeBasic.themeTime,
        applyTime: this.themeBasic.applyTime,
        themeChannelNames:this.themeBasic.themeChannelNames
      }
      for(let key in data){
        if(data[key]&&data[key].length!==0){
          return true
        }
      }
      return false
    },
  },
  created() {
    this.init()
  },
  methods: {
    themeTimeFocus(){
      // （转场需求修改，暂时不需要）
      // if(this.confirmed){
      //   if(this.themeBasic.themeChannelNames.length>0){
      //     this.$alert(`修改执行时间后转场配额信息将被清空!`, '提示', {
      //       confirmButtonText: '确定',
      //       confirmButtonClass: 'btn-red',
      //       type: 'warning'
      //     }).then(() => {
      //     })
      //   }
      // }
    },
    confirmChangeThemeTime(){
      this.confirmed = !this.confirmed
    },
    init(){
      this.$store.dispatch('getGameplanCityPoolIgniteCityPoolList')
      this.$store.dispatch('getGameplanConfigIgniteOptions')
      this.isHistory = this.$route.query.isHistory
      this.employeeLevel = this.userInfo.employeeLevel
      this.getGameplanConfigFull()
    },
    // 上传文件
    getManualFileId (file) {
      this.themeBasic.manualFileId = file.fileId
    },
    getExecTemplateId (file) {
      this.themeBasic.execTemplateId = file.fileId
    },
    // 删除文件
    clearManualFileId (file) {
      this.themeBasic.manualFileId = ''
      this.errorList = []
    },
    clearExecTemplateId (file) {
      this.themeBasic.execTemplateId = ''
      this.errorList = []
    },
    getConfigItemList() {
      let themeChannelForm = []
      for (let detail of this.fullConfig) {
        if(this.themeBasic.themeChannelNames.indexOf('detail.themeChannelName')===-1){
          for (let item of this.themeBasic.themeChannelNames) {
            if (item === detail.themeChannelName) {
              this.themeChannelCodes.push(detail.themeChannelCode)
              //themeChannelForm.push(detail)
            }
          }
        }
      }
      return themeChannelForm
    },
    async getGameplanThemeInfo() {
      this.loading = true
      let params = {
        themeId:this.$route.query.themeId
        //themeId:7
      }
      const { data } = await gameplanApi.getGameplanThemeInfo(params);
      if (data.resultCode === "0") {
        this.themeInfo = data.resultData?.themeInfo || [];
        if(!this.isHistory){
          this.themeBasic.themeName = this.themeInfo.themeBasic.themeName
          if(this.themeInfo.themeBasic.themeStartTime&&this.themeInfo.themeBasic.themeEndTime){
            this.themeBasic.themeTime.splice(0,0,this.themeInfo.themeBasic.themeStartTime,this.themeInfo.themeBasic.themeEndTime)
          }
          if(this.themeInfo.themeBasic.applyStartTime&&this.themeInfo.themeBasic.applyEndTime){
            this.themeBasic.applyTime.splice(0,0,this.themeInfo.themeBasic.applyStartTime,this.themeInfo.themeBasic.applyEndTime)
          }
          this.$store.commit('SET_THEME_TIME',this.themeBasic.themeTime)
          this.themeBasic.prNumber = this.themeInfo.themeBasic.prNumber
          this.themeBasic.brandName = this.themeInfo.themeBasic.gpPrDTO.brandName
          this.themeBasic.brandName = this.themeInfo.themeBasic.gpPrDTO.subBrandName
          this.themeId = this.themeInfo.themeBasic.themeId  || this.$route.query.themeId || ''
        }else {
          this.themeId = ''
        }
        //this.themeBasic.manualFileId = this.themeInfo.themeBasic.manualFileId
        //this.themeBasic.execTemplateId = this.themeInfo.themeBasic.execTemplateId
        if(this.themeInfo.themeBasic.execTemplateUri){
          let execTemplateInfo ={
            name:this.themeInfo.themeBasic.execTemplateName,
            url:this.themeInfo.themeBasic.execTemplateUri,
            fileId:this.themeInfo.themeBasic.execTemplateId
          }
          this.execTemplate.splice(0,0,execTemplateInfo)
          this.themeBasic.execTemplateId = this.themeInfo.themeBasic.execTemplateId
        }
        if(this.themeInfo.themeBasic.manualFileUri){
          let manualFileInfo = {
            name:this.themeInfo.themeBasic.manualFileName,
            url:this.themeInfo.themeBasic.manualFileUri,
            fileId:this.themeInfo.themeBasic.manualFileId
          }
          this.manualFile.splice(0,0,manualFileInfo)
          this.themeBasic.manualFileId = this.themeInfo.themeBasic.manualFileId
        }
        // this.detailList = this.themeInfo.detailList
        let themeChannels = this.themeInfo.themeBasic.themeChannels
        let themeChannelCodes = this.themeInfo.themeBasic.themeChannelCodes
        for (let detail of this.fullConfig) {
          for (let item of themeChannels) {
            if (item.themeChannelName === detail.themeChannelName) {
              this.themeBasic.themeChannelNames.push(detail.themeChannelName)
            }
          }
        }
        if(this.themeInfo.detailList&&this.themeInfo.detailList.length>0){
          this.saveDetailList = []
          for(let j=0;j<this.themeInfo.detailList.length;j++){
            let detail = this.themeInfo.detailList[j]
            for(let i=0;i<themeChannelCodes.length;i++){
              if(themeChannelCodes[i] === detail.themeDetail.themeChannelCode){
                if(!this.saveDetailList[i]){
                  let data = [detail]
                  this.saveDetailList[i]=data
                }else {
                  this.saveDetailList[i].push(detail)
                }
              }
            }
          }
        }
        this.themeChannelCodes = this.themeInfo.themeBasic.themeChannelCodes
        this.dataValid = this.isDataValid
      }
      this.loading = false
    },
    async getGameplanConfigFull() {
      this.loading = true
      const { data } = await gameplanApi.getGameplanConfigFull();
      if (data.resultCode === "0") {
        this.fullConfig = data.resultData?.fullConfig || [];
        this.assignBuList = data.resultData?.assignBuList || []
        this.assignRegionList = data.resultData?.assignRegionList || []
        this.assignAreaList = data.resultData?.assignAreaList || []
        //this.total = data.resultData.pageInfo.totalCounts
      }
      if(this.$route.query.themeId){
        this.getGameplanThemeInfo()
      }else {
        this.loading = false
      }
    },
    submit(){
      this.loading = true
      this.valid = true
      this.showConfirmDialog=false
      this.detailList = []
      this.rateErrorList = []
      for(let item of this.themeChannelForm){
        if(this.themeChannelCodes.indexOf(item.themeChannelCode)==-1){
          this.themeChannelCodes.push(item.themeChannelCode)
        }
      }
      this.themeBasic.themeChannelCodes=this.themeChannelCodes
      this.themeBasic.applyStartTime = this.themeBasic.applyTime[0]
      this.themeBasic.applyEndTime = this.themeBasic.applyTime[1]
      this.themeBasic.themeStartTime = this.themeBasic.themeTime[0]
      this.themeBasic.themeEndTime = this.themeBasic.themeTime[1]
      this.themeBasic.prNumber? '' : this.themeBasic.prNumber = this.$route.query.prNumber
      this.themeBasic.buToCity = 0
      this.themeBasic.themeId = this.themeId
      if(this.employeeLevel>=90){
        this.themeBasic.orgLevel = 'hq'
      }else if(this.employeeLevel>=60&& this.employeeLevel<90){
        this.themeBasic.orgLevel = 'bu'
      }else if(this.employeeLevel>=45&& this.employeeLevel<60){
        this.themeBasic.orgLevel = 'region'
      }
      if(this.$refs.configItemRef&&this.$refs.configItemRef.length>0){
        for(let i=0;i<this.$refs.configItemRef.length;i++){
          this.$refs.configItemRef[i].submit(this.operateType)
          //this.$refs.configDetailRef[i].submit()
        }
      }
      let data = {
        detailList:this.detailList,
        themeBasic:this.themeBasic
      }
      if(this.valid){
        this.operateType ==='save'?this.handleGetGameplanThemeSave(data):this.getGameplanThemeSubmit(data)
      }else {
        this.loading = false
        this.$alert(`${this.rateErrorList.length>0?this.rateErrorList.join('、')+'活动形式比例未填写，':'页面有必填数据未填写，'}请填写后重新提交！`, '提示', {
          confirmButtonText: '确定',
          confirmButtonClass: 'btn-red',
          callback: () => {
          }
        });
      }
    },
    handleSubmit(item,valid,type){
      if(!valid){
        this.valid = false
      }
      //console.log(valid,type);
      if(type){
        if(this.rateErrorList.indexOf(type)==-1){
          this.rateErrorList.push(type)
        }
      }
      this.detailList.push(item)
    },
    handleOperation(type){
      this.operateType = type
      this.$confirm(`是否要${this.operateType==='submit'?'提交':'保存'}当前数据？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async() => {
          this.submit()
        }).catch(() => {
        });
      //this.showConfirmDialog=true
    },
    handleAddTime(data){
      // console.log(data);
      // console.log(this.themeBasic.themeTime);
      //this.confirmed = false
      // if(oldv.length===0&&val!==oldv){
      //   this.$confirm(`修改执行时间后转场配额信息将被清空，是否确认修改执行时间？`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     confirmButtonClass: 'btn-red',
      //     type: 'warning'
      //   }).then(async() => {
          
      //   }).catch(() => {
      //   });
      // }
      this.$store.commit('SET_THEME_TIME',data)
    },
    handleGetGameplanThemeSave(data){
      if(Object.keys(this.themeInfo).length === 0){
        this.getGameplanThemeSave(data)
      }else {
        this.getGameplanThemeSaveUpdate(data)
      }
    },
    async getGameplanThemeSave(data) {
      //console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSave(data);
      if (res.data.resultCode === "0") {
        this.$message.success("保存成功！")
        this.$router.go(-1)
      }
      this.loading = false
    },
    async getGameplanThemeSaveUpdate(data) {
      //console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSaveUpdate(data);
      if (res.data.resultCode === "0") {
        this.$message.success("保存成功！")
        this.$router.go(-1)
      }
      this.loading = false
    },
    async getGameplanThemeSubmit(data) {
      //console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSubmit(data);
      if (res.data.resultCode === "0") {
        this.$message.success("提交成功！")
        this.$router.go(-1)
      }
      this.loading = false
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409eff !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409eff !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #101010;
}

::v-deep .activity_new .el-form-item {
  min-width: 48%;
  margin-bottom: 24px;

  .el-form-item__label {
    color: black;
  }
}
::v-deep .el-checkbox__input {
    margin-top: -8px;
}

::v-deep .el-checkbox__label {
    margin-top: -2px;
}
.content-wrapper {

  .activity_new {
    position: relative;
    margin-top: -50px;

    .activity-new-card {
      padding: 20px 10px 20px 0px;
      background-color: #ffffff;
      color: #101010;
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      font-family: SourceHanSansSC-bold;
      display: flex;
      justify-content: flex-start;

      .po_config_btn {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: -25px;
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        background-color: #539efe;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        font-family: Roboto;
      }
    }

    .activity_channel_checkbox {
      margin-top: 0px;
    }

    .activity_channel_checkbox_label {
      text-align: center;
      position: relative;
      top: 15px;
      line-height: 18px;
    }
  }
}

.upload_section {
  margin: 30px 0 0 8px;
  font-size: 12px;
}
.upload_item {
    display: flex;
    margin-left: 30px;
  }

  .upload_item_title {
    width: 220px;
    font-size: 14px;
    font-weight: 600;
    padding: 20px 10px;
  }

  .upload_item_btn {
    cursor: pointer;
    margin-top: 13px;
    height: 30px;
    line-height: 30px;
    width: 100px;
    border-radius: 5px;
    text-align: center;
    vertical-align: middle;
    color: white;
    background-color: rgb(204, 0, 0);
  }

.btn_section{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin-top: 60px;
  .normal_btn{
    width: 100px;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
  }
  .btn_bg_white{
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
    margin-right: 100px;
  }
  .btn_bg_white_disadled{
    border: 1px solid $base-grey4 !important;
    color: $base-grey4 !important;
    cursor: no-drop;
    margin-right: 100px;
  }
  .btn_bg_red{
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
  .btn_bg_red_disabled{
    color: white;
    cursor: no-drop;
    background-color: $base-grey4 !important;
    border: 1px solid $base-grey4 !important;
  }
}
</style>
